// extracted by mini-css-extract-plugin
export default {"UpAsyncLoding":"UpAsyncLoding_UpAsyncLoding__wk5j2"};